import React, { useCallback, useState, useEffect, Fragment, useContext } from 'react';
import Button from '../../components/bronson/Button';
import Traductor from '../Traductor';
import { VehiclesContext } from '../../contexts/VehiclesContext';
import {
    formatPrice,
    formatNumber,
} from '../../js/components/shared/vehicleFunctions';
import ModalUpdatePriceVehicleNotBuy from './ModalUpdatePriceVehicleNotBuy';
import TransportService from '../../services/TransportService';
import Globals from '../../Globals';
import { withCookies } from 'react-cookie';
import '../../css/components/shared/vehicleCard/VehicleCard.css';
import Tag from '../bronson/Tag';
import Carousel from '../bronson/Carousel';
import {
    isAppleDeviceOrNavegatorForDates,
    getImageSource,
    getCookie,
    disableHTMLOverflow
} from '../../Functions';

import DetailsModal from '../batches/Details/DetailsModal';
import SellService from '../../services/SellService';
import ToastNotification from '../bronson/ToastNotification';
import { Portal } from 'react-portal';
import { vehicleStateEnum } from '../../enums/VehicleStateEnum';

function VehicleAdjudgedCard({ cookies, vehicleParent, selectedDetail }) {
    const t = new Traductor();
    const { setSelectedVehicle } = useContext(VehiclesContext);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [modalUpdatePrice, setModalUpdatePrice] = useState(false);
    const [modalDocuments, setModalDocuments] = useState(false);
    const [docsForSale, setdocsForSale] = useState(null);
    const [error, setError] = useState();
    const [loading, setLoading] = useState();
    const [transportRequest, setTransportRequest] = useState(null);
    const [vehicle] = useState(vehicleParent);
    const [destination, setDestination] = useState(
        vehicleParent.DescriptionDestiny
    );
    const [transportPrice, setTransportPrice] = useState(
        vehicleParent.TransportPrice
    );
    const [dealerEstadistics, setDealerEstadistics] = useState(
        vehicleParent.ConcesionarioExposition
    );
    const [brandExposition, setBrandExposition] = useState(
        vehicleParent.BranchExpositionDescription
    );
    const [showToast, setShowToast] = useState(null);

    let optionsAdvancedFiltersMobile = {
        id: vehicle.IdVehicleAdjudication
            ? vehicle.IdVehicleAdjudication
            : null,
        text: vehicle.skeleton
            ? ''
            : t.getTraduction('EditDataAndRegeneratedEmail'),
        class: 'c-btn c-btn--full ',
        disabled: vehicle.PayDate != null ? true : false,
    };

    let optionsDownoadTransferDocuments = {
        id: vehicle.Plate + t.getTraduction('DownloadTransferDocuments'),
        text: t.getTraduction('DownloadTransferDocuments'),
        class: 'c-btn c-btn--full ',
        loading: loading === vehicle.Plate + t.getTraduction('DownloadTransferDocuments'),
        disabled: vehicle.PayDate != null ? false : true,
    };

    let optionsDownoadDeliveryCertificate = {
        id: vehicle.Plate + t.getTraduction('DeliveryCertificate'),
        text: t.getTraduction('SendDeliveryCertificateByEmail'),
        class: 'c-btn  c-btn--secondary  c-btn--icon u-mr',
        icon: {
            title: 'download',
            image: 'semantic-mail',
            isAfterText: true,
        },
        loading: loading === vehicle.Plate + t.getTraduction('DeliveryCertificate'),
        disabled: vehicle.PayDate != null ? false : true,
    };

    useEffect(() => {
        window.addEventListener('resize', getWindowWitdh);
    }, []);

    const getWindowWitdh = () => {
        setWindowWidth(window.innerWidth);
    };

    const printModalUpdatePrice = () => {
        if (!modalUpdatePrice || !transportRequest) return null;
        return (
            <ModalUpdatePriceVehicleNotBuy
                vehicle={vehicle}
                closeModal={closeModalAlert}
                transportRequest={transportRequest}
            ></ModalUpdatePriceVehicleNotBuy>
        );
    };

    const ConvertRegister = useCallback(items => {
        const array = [];
        const ass = items?.forEach(x => {
            const obj = {};
            obj.DocumentId = x.DocumentId;
            obj.FileName = x.FileName;
            array.push(obj);
        });
        return array;
    });

    const printModalDocuments = () => {
        let html = null;
        html = (
            <Fragment>
                <div className="o-layout o-layout--equal-height u-p-none">
                    <div className="o-layout__item u-1/1 u-p-none u-mt-none">
                        <Button
                            options={optionsDownoadDeliveryCertificate}
                            onClick={() =>
                                sendEmailDelivery()
                            }
                        ></Button>
                    </div>
                    <hr />

                    {ConvertRegister(docsForSale)?.map(function (data, i) {
                        return (
                            <div key={i} className="o-layout__item u-1/1 u-p-none u-mt-none">
                                <Button
                                    options={
                                        {
                                            id: "SaleDoc" + data.DocumentId,
                                            text: data.FileName,
                                            class: 'c-btn  c-btn--secondary  c-btn--icon u-mr',
                                            disabled: false,
                                            icon: {
                                                title: 'download',
                                                image: 'semantic-download',
                                                isAfterText: true,
                                            },
                                            loading: loading === vehicle.Plate + data.DocumentId,
                                        }
                                    }
                                    onClick={() =>
                                        dowloadSaleDocument(data.DocumentId)
                                    }
                                ></Button>
                            </div>
                        )
                    })}

                </div>
            </Fragment>
        );
        return (
            <DetailsModal
                visible={modalDocuments}
                large={false}
                onActionPress={() => setModalDocuments(null)}
                onClose={() => setModalDocuments(null)}
                title={t.getTraduction('TransferDocuments')}
                content={html}
                leftButton={t.getTraduction('Close')}
            />
        );
    };

    const printCardTag = (mobile = false, isFloating = true) => {
        let text = null;
        let className = [];

        if (isFloating) {
            className.push('c-vehicle-card__tag-payment-status');
        }

        if (mobile) {
            if (vehicle.PayDate === null || vehicle.PayDate === '') {
                text = t.getTraduction('Pending');
                className = ['error'];
            }
        } else {
            if (windowWidth > 720) {
                if (vehicle.PayDate == null) {
                    text = t.getTraduction('Outstanding');
                    className.push('error');
                } else {
                    text = t.getTraduction('Payed');
                    className.push('success');
                }
            }
        }

        if (text == null) return null;
        return <Tag classes={className} text={text}></Tag>;
    };

    const setSelectedDetail = () => {
        selectedDetail(vehicle);
        setSelectedVehicle(vehicle);
    };

    const openUpdatePriceVehicleNotBuy = () => {
        setModalUpdatePrice(true);
        setSelectedVehicle(vehicle);
        getTransportRequest(vehicle.Id);
    };

    const openDocumentModal = () => {
        getDocsForSale();
    };


    const sendEmailDelivery = async () => {
        setLoading(vehicle.Plate + t.getTraduction('DeliveryCertificate'));
        let data = {
            VehicleId: vehicle.Id,
            UserName: getCookie(process.env.REACT_APP_USER_ID)
        };
        await new SellService()
            .sendEmailDeliveryCertificate(
                data,
                cookies.get(Globals.COOKIES.JWT).AccessToken
            )
            .then(response => {
                if (
                    response &&
                    response.statusCode == 200 &&
                    response.body.Result != null &&
                    response.body.Result == 'true'
                ) {
                    alert(t.getTraduction('SendDeliveryCertificateByEmailOK'))
                } else {
                    if (
                        response &&
                        response.body &&
                        response.body.Errors &&
                        response.body.Errors.length > 0
                    ) {
                        alert(response.body.Errors[0].Value);
                    } else {
                        alert(t.getTraduction('SendDeliveryCertificateByEmailError'));
                    }
                }
            });
        setLoading(false);
    };

    const getDocsForSale = async () => {
        setSelectedVehicle(vehicle);
        setLoading(vehicle.Plate + t.getTraduction('DownloadTransferDocuments'));
        try {
            const response = await new SellService().getDocumentsForSale(
                cookies.get(Globals.COOKIES.JWT).AccessToken,
                {
                    VehicleId: vehicle.Id,
                }
            );
            if (response) {
                var model = JSON.parse(JSON.parse(response.body).Result);
                setdocsForSale(model);
            }
        } catch (error) {
            setdocsForSale(null);

        } finally {
            setLoading(null);
            setModalDocuments(true);
        }
    };

    const dowloadSaleDocument = async (Id) => {
        setSelectedVehicle(vehicle);
        setLoading(vehicle.Plate + Id);
        try {
            const response = await new SellService().getDocumentForSaleById(
                cookies.get(Globals.COOKIES.JWT).AccessToken,
                {
                    DocumentId: Id,
                }
            );
            if (response) {
                var model = JSON.parse(JSON.parse(response.body).Result);
                var sliceSize = 2000;
                var byteCharacters = window.atob(model.File);
                var byteArrays = [];
                var typeFile = "application/pdf";
                var typeEnding = "pdf";
                var signatures = {
                    JVBERi0: "application/pdf",
                    R0lGODdh: "image/gif",
                    R0lGODlh: "image/gif",
                    iVBORw0KGgo: "image/png",
                    TU0AK: "image/tiff",
                    "/9j/": "image/jpg"
                };
                var endings = {
                    JVBERi0: "pdf",
                    R0lGODdh: "gif",
                    R0lGODlh: "gif",
                    iVBORw0KGgo: "png",
                    TU0AK: "tiff",
                    "/9j/": "jpg"
                };

                for (var s in signatures) {
                    if (model.File.indexOf(s) === 0) {
                        var x = signatures[s];

                        typeFile = x;
                        typeEnding = endings[s];
                        break;
                    }
                }

                for (
                    var offset = 0;
                    offset < byteCharacters.length;
                    offset += sliceSize
                ) {
                    var slice = byteCharacters.slice(
                        offset,
                        offset + sliceSize
                    );
                    var byteNumbers = new Array(slice.length);

                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }
                    var byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }
                var blob = new Blob(byteArrays, {
                    type: typeFile,
                });
                var fileURL = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                a.href = fileURL;
                a.download = 'Documento para venta -' + vehicle.Plate + '.' + typeEnding;
                a.click();
                window.URL.revokeObjectURL(fileURL);
                a.remove();
            }
        } catch (error) {
            setError({
                Content: t.getTraduction('SaleDocumentDownloadError')(
                    vehicle.Plate
                ),
            });
        } finally {
            setLoading(null);
        }
    };


    const getTransportRequest = async vehicleId => {
        await new TransportService()
            .GetDataSolicitudeTransportByVehicleId(
                cookies.get(Globals.COOKIES.JWT).AccessToken,
                vehicleId
            )
            .then(response => {
                if (response && response.Result != null) {
                    setTransportRequest(JSON.parse(response.Result));
                }
            });
    };

    const closeModalAlert = newValues => {
        if (Object.keys(newValues).length > 0) {
            let {
                newDestination,
                newTransportPrice,
                newDealerEstadistics,
                newBrandExposition,
            } = newValues;
            setTransportPrice(newTransportPrice);
            setDestination(newDestination);
            setDealerEstadistics(newDealerEstadistics);
            setBrandExposition(newBrandExposition);
            setShowToast({ title: '¡Guardado!', text: 'Datos actualizados correctamente', type: 'success', closeText: 'Cerrar', timeout: false });
        }
        setModalUpdatePrice(false);
        disableHTMLOverflow(false);
    };

    const printCardTitles = () => {
        let className = 'u-1/1 u-mt u-mb-small u-pl u-pr';
        if (windowWidth > 720) {
            className = 'u-9/12 u-m-none u-p-none';
        }
        return (
            <div
                className={'o-layout__item ' + className}
                onClick={() => setSelectedDetail()}
            >
                <p className="c-card__title">
                    {vehicle.Plate}
                    {vehicle.BrandName ? ' - ' + vehicle.BrandName : ''}
                </p>
            </div>
        );
    };

    const printVehicleDates = (mobile = false) => {
        let html = null;

        if (!mobile && windowWidth >= 720) {
            html = (
                <div className="o-layout__item u-1/1 u-m-none u-pl-none">
                    <ul className="list-inline">
                        <li className="list-inline__item">
                            <p className="u-m-none">
                                <span className="u-text-disabled">
                                    {t.getTraduction('BuyDate')}:{' '}
                                </span>
                                <span>
                                    {vehicle.BuyDate
                                        ? new Date(
                                            isAppleDeviceOrNavegatorForDates(
                                                vehicle.BuyDate
                                            )
                                        ).toLocaleDateString()
                                        : '--'}
                                </span>
                            </p>
                        </li>
                        <li className="list-inline__item">
                            <p className="u-m-none">
                                <span className="u-text-disabled">
                                    {t.getTraduction('PayDate')}:{' '}
                                </span>
                                <span>
                                    {vehicle.PayDate
                                        ? new Date(
                                            isAppleDeviceOrNavegatorForDates(
                                                vehicle.PayDate
                                            )
                                        ).toLocaleDateString()
                                        : '--'}
                                </span>
                            </p>
                        </li>
                    </ul>
                </div>
            );
        } else {
            if (mobile && windowWidth < 720) {
                html = (
                    <div className="o-layout__item u-1/1 u-mt-small">
                        <ul className="list-inline list-inline--mobile-block">
                            <li className="list-inline__item">
                                <p className="u-m-none">
                                    <span className="u-text-disabled">
                                        {t.getTraduction('BuyDate')}{' '}
                                    </span>
                                    <span className="u-block u-mt-xsmall">
                                        {vehicle.BuyDate
                                            ? new Date(
                                                isAppleDeviceOrNavegatorForDates(
                                                    vehicle.BuyDate
                                                )
                                            ).toLocaleDateString()
                                            : '--'}
                                    </span>
                                </p>
                            </li>
                            <li className="list-inline__item">
                                <div className="u-m-none">
                                    {vehicle.PayDate ? (
                                        <Fragment>
                                            <p className="u-text-disabled u-mb-xsmall">
                                                {t.getTraduction('PayDate')}{' '}
                                            </p>
                                            <span className="u-block u-mt-xsmall">
                                                {vehicle.PayDate
                                                    ? new Date(
                                                        isAppleDeviceOrNavegatorForDates(
                                                            vehicle.PayDate
                                                        )
                                                    ).toLocaleDateString()
                                                    : '--'}
                                            </span>
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <p className="u-text-disabled u-mb-xsmall">
                                                {t.getTraduction('PayState')}
                                            </p>
                                            {printCardTag(true, false)}
                                        </Fragment>
                                    )}
                                </div>
                            </li>
                        </ul>
                    </div>
                );
            }
        }
        return html;
    };
    const vehicleRetiredStates = Object.freeze([
        vehicleStateEnum.SOLD_PENDING_PAYMENT,
        vehicleStateEnum.SOLD_PENDING_DOCUMENTATION,
        vehicleStateEnum.SOLD_AND_TRANSFERRED,
    ]);

    const getTransportDisplayValues = () => {
        const stateCode = String(vehicleParent?.SubStateLogisticsCode || '');
        const stateDescription = vehicleParent?.SubStateLogisticsDescription || '--';

        const origin = vehicle?.DescriptionOrigin || '--';
        const destinationValue = destination || '--';
        const lastLocationValue = vehicle?.Origin?.Description || '--';

        const isVehicleRetired =
            !(vehicle?.RepurchaseObligation >= 0) &&
            !(vehicle?.Origin?.Description || vehicle?.OriginDescription) &&
            vehicleRetiredStates.includes(String(vehicle?.CodeTypeStateVehicle));

        let originToShow = origin;
        let destinationToShow = destinationValue;
        let lastLocationToShow = lastLocationValue;

        switch (stateCode) {
            case '4': // En trasiego
            case '3': // Pte. gestionar orden de transporte
                originToShow = origin;
                destinationToShow = destinationValue;
                lastLocationToShow = vehicle?.Origin?.Description
                break;

            case '1': // Pte. de orden de transporte
            case '2': // Transportado
                originToShow = '--';
                destinationToShow = '--';
                lastLocationToShow = vehicle?.Origin?.Description
                break;

            default:
                originToShow = origin;
                destinationToShow = destinationValue;
                lastLocationToShow = vehicle?.Origin?.Description;
                break;
        }

        return {
            stateDescription: isVehicleRetired ? '--' : stateDescription,
            originToShow,
            destinationToShow,
            lastLocationToShow: isVehicleRetired ? t.getTraduction('VehicleRetired') : lastLocationToShow,
        };
    };

    const printTransportData = () => {

        const {
            stateDescription,
            originToShow,
            destinationToShow,
            lastLocationToShow,
        } = getTransportDisplayValues();

        let html = null;
        if (windowWidth >= 720 && windowWidth < 1280) {
            html = (
                <Fragment>
                    <div className="o-layout__item u-1/1 u-p-none u-mt-none">
                        <p className="u-mb-xsmall">
                            <span className="u-text-disabled">
                                {t.getTraduction('Origin')}:
                            </span>{' '}
                            {originToShow}
                        </p>
                    </div>
                    <div className="o-layout__item u-1/1 u-p-none u-mt-none">
                        <p className="u-mb-xsmall">
                            <span className="u-text-disabled">
                                {t.getTraduction('Destination')}:{' '}
                            </span>
                            {destinationToShow}
                        </p>
                    </div>

                    <div className="o-layout__item u-1/1 u-p-none u-mt-none">
                        <p className="u-mb-xsmall">
                            <span className="u-text-disabled">
                                {t.getTraduction('TransportState')}:{' '}
                            </span>
                            {stateDescription}
                        </p>
                    </div>

                    <div className="o-layout__item u-1/1 u-p-none u-mt-none">
                        <p className="u-mb-xsmall">
                            <span className="u-text-disabled">
                                {t.getTraduction('LastLocation')}:{' '}
                            </span>
                            {lastLocationToShow}
                        </p>
                    </div>
                </Fragment>
            );
        } else {
            html = (
                <Fragment>
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                        <p className="u-mb-xsmall">
                            <span className="u-text-disabled">
                                {t.getTraduction('Origin')}
                            </span>
                        </p>
                        <p className="u-mb-xsmall">
                            {originToShow}
                        </p>
                    </div>
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                        <p className="u-mb-xsmall">
                            <span className="u-text-disabled">
                                {t.getTraduction('Destination')}
                            </span>
                        </p>
                        <p className="u-mb-xsmall">
                            {destinationToShow}
                        </p>
                    </div>
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                        <p className="u-mb-xsmall">
                            <span className="u-text-disabled">
                                {t.getTraduction('TransportState')}:
                            </span>
                        </p>
                        <p className="u-mb-xsmall">
                            {stateDescription}
                        </p>
                    </div>
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                        <p className="u-mb-xsmall">
                            <span className="u-text-disabled">
                                {t.getTraduction('LastLocation')}:{' '}
                            </span>
                        </p>
                        <p className="u-mb-xsmall">
                            {lastLocationToShow}
                        </p>
                    </div>
                </Fragment>
            );
        }

        return html;
    };

    const printDocumentDownloadData = () => {
        let html = null;
        if (vehicle.ReasonEntryRemaCode === "25" && vehicle.CodeBuyType === "R") {
            html = (
                <Fragment>
                    <hr></hr>
                    <div className="o-layout__item u-1/1 u-p-none u-mt-none">
                        <Button
                            options={optionsDownoadTransferDocuments}
                            onClick={() =>
                                openDocumentModal()
                            }
                        ></Button></div>
                </Fragment>
            );
        }
        return html;
    };

    const printExpositionsData = () => {
        let html = null;
        if (windowWidth >= 720 && windowWidth < 1280) {
            html = (
                <Fragment>
                    <div className="o-layout__item u-1/1 u-p-none u-mt-none">
                        <p className="u-text-disabled u-mb-xsmall">
                            <span className="u-text-disabled">
                                {t.getTraduction('EBrand')}:{' '}
                            </span>
                            {vehicle.BranchExpositionDescription}
                        </p>
                    </div>
                    <div className="o-layout__item u-1/1 u-p-none u-mt-none">
                        <p className="u-text-disabled u-mb-xsmall">
                            <span className="u-text-disabled">
                                {t.getTraduction('EConcessionaire')}:{' '}
                            </span>
                            {vehicle.ConcesionarioExposition}
                        </p>
                    </div>
                </Fragment>
            );
        } else {
            html = (
                <Fragment>
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                        <p className="u-text-disabled u-mb-xsmall rema-text-overflow--ellipsis">
                            <span className="u-text-disabled">
                                {t.getTraduction('ExhibitionBrand')}
                            </span>
                        </p>
                        <p className="u-mb-xsmall">{brandExposition}</p>
                    </div>
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                        <p className="u-text-disabled u-mb-xsmall rema-text-overflow--ellipsis">
                            <span className="u-text-disabled">
                                {t.getTraduction('ExhibitionConcessionaire')}
                            </span>
                        </p>
                        <p className="u-mb-xsmall">{dealerEstadistics}</p>
                    </div>
                </Fragment>
            );
        }
        return html;
    };

    const printBuyType = () => {
        let text = '';
        switch (vehicle.CodeBuyType) {
            case 'P':
                text = t.getTraduction('Puja');
                break;
            case 'C':
                text = t.getTraduction('CompraDirecta');
                break;
            case 'R':
                text = t.getTraduction('dealerReceptor');
            default:
                break;
        }
        if (text == '') return null;
        return (
            <li className="list-inline__item">
                <Tag
                    classes={['c-vehicle-card__tag-payment-type']}
                    text={text}
                ></Tag>
            </li>
        );
    };

    const getImagesList = (typeList = false) => {
        if (typeList) return [getImageSource(vehicle.ImageSource)];
        return (
            <img
                src={getImageSource(vehicle.ImageSource)}
                onClick={() => setSelectedVehicle(vehicle)}
                alt="vehicle"
            />
        );
    };

    const printCardImageMobileVersion = () => {
        if (windowWidth > 720) return null;

        let optionsCarousel = {
            id: 'c-vehicle-card__carousel-' + vehicle.Id,
            next: true,
            images: getImagesList(true),
            flickity: {
                imagesLoaded: false,
            },
        };

        return (
            <div
                className="c-vehicle-card__carousel-container"
                onClick={() => setSelectedDetail()}
            >
                <Carousel
                    options={optionsCarousel}
                    onClickFunction={setSelectedDetail}
                />
                {/* tags */}
            </div>
        );
    };

    const printCardHeader = () => {
        if (windowWidth > 720) {
            return (
                <div className="o-layout">
                    <div className="o-layout__item u-1/1 u-p-none u-m-none">
                        <div className="c-vehicle-card__header-left-container">
                            {getImagesList()}
                        </div>
                        <div className="c-vehicle-card__header-right-container">
                            <div className="o-layout">
                                {printCardTitles()}
                                <div className="o-layout__item u-1/1 u-p-none u-mb-small">
                                    <ul className="list-inline">
                                        <li className="list-inline__item u-mr">
                                            <p className="u-m-none">
                                                {vehicle.RegistrationDate
                                                    ? vehicle.RegistrationDate +
                                                    ' | '
                                                    : null}
                                                {vehicle.Kms
                                                    ? formatNumber(
                                                        vehicle.Kms
                                                    ) + ' Km'
                                                    : null}
                                            </p>
                                        </li>
                                        {printBuyType()}
                                    </ul>
                                </div>
                                {printVehicleDates()}
                            </div>
                        </div>
                        <div className="c-vehicle-card__tags-payment">
                            {printCardTag(false, false)}
                            {vehicle.ImporteIncentivoRecompraAC && vehicle.ImporteIncentivoRecompraAC > 1 ? (
                                <Tag
                                    classes={['success']}
                                    text={t.getTraduction('IncentiveAvailable')}
                                />
                            ) : null}
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="o-layout u-mb">
                    {printCardTitles()}
                    <div className="o-layout__item u-1/1">
                        <ul className="list-inline u-pl-small u-pr-small">
                            <li className="list-inline__item u-mr">
                                <p className="u-m-none">
                                    {vehicle.RegistrationDate
                                        ? vehicle.RegistrationDate + ' | '
                                        : null}
                                    {vehicle.Kms
                                        ? formatNumber(vehicle.Kms) + ' Km'
                                        : null}
                                </p>
                            </li>
                            {printBuyType()}
                        </ul>
                        {printVehicleDates(true)}
                    </div>
                </div>
            );
        }
    };

    return (
        <article
            id={
                'card-vehicle-' + (vehicle ? vehicle.IdVehicleAdjudication : '')
            }
            className={
                'c-card c-card--image c-vehicle-card c-vehicle-card--adjudged u-text-left ' +
                (vehicle.skeleton ? 'c-vehicle-card--skeleton' : '')
            }
        >
            {printCardImageMobileVersion()}
            <header
                className="c-card__header u-pb-none"
                onClick={setSelectedDetail}
            >
                {printCardHeader()}
            </header>
            <div className="c-card__body u-pl-none u-pr-none u-pt u-pt-none@s u-pb-none">
                <div className="o-layout o-layout--equal-height u-p-none">
                    <div className="o-layout__item u-2/5 u-2/6@l u-1/1@s first-cell">
                        <div className="o-layout">
                            <div className="o-layout__item u-1/1 u-p-none u-mt-none u-mb-small">
                                <p className="u-h6 u-mb-small">
                                    {t.getTraduction('Comprador')}
                                </p>
                                <p>
                                    {vehicle.BuyerName}
                                    {vehicle.BuyerNumDocument
                                        ? '(' + vehicle.BuyerNumDocument + ')'
                                        : null}
                                </p>
                            </div>
                            {printExpositionsData()}
                        </div>
                    </div>
                    <div className="o-layout__item u-2/5 u-2/6@l u-1/1@s first-cell">
                        <div className="o-layout u-rema-full-weight">
                            <div className="o-layout__item u-1/1 u-p-none u-m-none u-mb-small">
                                <p
                                    className={
                                        'u-h6 ' +
                                        (windowWidth > 720 ? 'u-mb-large' : '')
                                    }
                                >
                                    {t.getTraduction('Transport')}
                                </p>
                            </div>
                            {printTransportData()}
                        </div>
                    </div>
                    <div className="o-layout__item u-1/5 u-2/6@l u-1/1@s second-cell">
                        <div className="o-layout u-rema-full-weight">
                            <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                                <p>{t.getTraduction('Vehicle')}</p>
                            </div>
                            <div className="o-layout__item u-1/2 u-p-none u-mt-none u-text-right">
                                <p>
                                    <strong>
                                        {vehicle.Price
                                            ? formatPrice(vehicle.Price)
                                            : ''}
                                    </strong>
                                </p>
                            </div>
                            {vehicle.ImporteIncentivoRecompraAC && vehicle.ImporteIncentivoRecompraAC > 1 ? (
                                <Fragment>
                                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                                        <p>{t.getTraduction('ImporteIncentivoRecompra')}</p>
                                    </div>
                                    <div className="o-layout__item u-1/2 u-p-none u-mt-none u-text-right">
                                        <p>
                                            <strong className="u-text-success">
                                                {new Intl.NumberFormat('ca', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(vehicle.ImporteIncentivoRecompraAC)}
                                            </strong>
                                            {' '}<small style={{ fontSize: '0.75em' }}>(iva incluido)</small>
                                        </p>
                                    </div>
                                </Fragment>
                            ) : null}
                            <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                                <p>{t.getTraduction('Transport')}</p>
                            </div>
                            <div className="o-layout__item u-1/2 u-p-none u-mt-none u-text-right">
                                <p>
                                    <strong>
                                        {' '}
                                        {transportPrice && transportPrice >= 0
                                            ? formatPrice(transportPrice)
                                            : '--'}
                                    </strong>
                                </p>
                            </div>
                            <hr />
                            <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                                <p>
                                    <strong>{t.getTraduction('Total')}</strong>
                                </p>
                            </div>
                            <div className="o-layout__item u-1/2 u-p-none u-mt-none u-text-right">
                                <p>
                                    <strong>
                                        {vehicle.Price
                                            ? formatPrice(
                                                parseFloat(vehicle.Price) +
                                                parseFloat(
                                                    transportPrice &&
                                                        transportPrice > 0
                                                        ? transportPrice
                                                        : 0
                                                )
                                            )
                                            : ''}{' '}
                                    </strong>
                                </p>
                            </div>
                            <div className="o-layout__item u-1/1 u-p-none u-mt-none">
                                <Button
                                    options={optionsAdvancedFiltersMobile}
                                    onClick={() =>
                                        openUpdatePriceVehicleNotBuy()
                                    }
                                ></Button>
                            </div>
                            {printDocumentDownloadData()}
                        </div>

                        <Portal>
                            <DetailsModal
                                visible={error}
                                large={false}
                                onActionPress={() => setError(null)}
                                onClose={() => setError(null)}
                                title={t.getTraduction('DownloadDocumentationTitleError')}
                                content={error?.Content}
                                leftButton={t.getTraduction('Close')}
                            />
                        </Portal>
                        {printModalUpdatePrice()}
                        {printModalDocuments()}
                    </div>
                </div>
            </div>
            {showToast && <ToastNotification options={showToast} closeToast={() => setShowToast(null)} />}
        </article>
    );
}

export default withCookies(VehicleAdjudgedCard);
